import React from 'react'
import { SolidUser } from '@rushable/icons'
import ConditionsItemForm from './ConditionsItemForm'
import type { IOptions } from 'components/Select/help'
import type { TFilterItem } from '../help/constant'

export default function DealCloserFilter({
  className,
  value,
  onChange,
  options,
}: TFilterItem) {
  return (
    <ConditionsItemForm
      className={className}
      icon={<SolidUser size={16} className='text-light-100' />}
      label='Deal closer'
      value={value}
      options={options as IOptions[]}
      onChange={onChange}
    />
  )
}
